<template>
  <b-container class="container-project">
    <div class="p-5 bg-dark text-white text-center" v-if="!showPayment">
      <div class="display-4 text-customer my-4 ">¡Atención!</div>
      <div class="lead">
        <i>Próximamente podrás realizar aquí todos tus pagos.</i>
      </div>
    </div>
    <div
      class="container-payments"
      v-else-if="payment_data.payments.length > 0"
    >
      <h2 class="text-center text-bold mt-4">
        Contrato Nº
        {{
          new Intl.NumberFormat("es-CL").format(payment_data.contract_number)
        }}
      </h2>
      <br />
      <b-overlay :show="loading" rounded="lg" spinner-variant="gold">
        <b-row style="width: 100%;" class="content-card">
          <b-col class="px-0">
            <b-table-simple condensed borderless hover>
              <tbody>
                <b-tr
                  class="d-none d-lg-table-row text-white text-center"
                  style="background-color:#707070"
                >
                  <b-th>Descripción</b-th>
                  <b-th>Monto Pactado</b-th>
                  <b-th>Fecha Pactada</b-th>
                  <b-th>Tipo Pago</b-th>
                  <b-th>Estado</b-th>
                  <b-th>Acción</b-th>
                </b-tr>
                <template v-for="(payment, key) in pageOfItems">
                  <b-tr
                    :key="'pay-tr' + key"
                    class="d-none d-lg-table-row payment-table"
                  >
                    <b-td>
                      {{ payment.descripcionPago }}
                    </b-td>
                    <b-td>
                      {{
                        new Intl.NumberFormat("es-CL").format(payment.montoPago)
                      }}
                      UF
                    </b-td>
                    <b-td>
                      {{ payment.fechaVencimientoPago | moment("DD-MM-YYYY") }}
                    </b-td>
                    <b-td>
                      <div
                        v-if="
                          payment.reciboPago && payment.reciboPago.length > 0
                        "
                      >
                        {{ payment.reciboPago[0].tipoPago }}
                      </div>
                      <div v-else>
                        -
                      </div>
                    </b-td>
                    <b-td>
                      <h5>
                        <b-badge
                          v-if="
                            is_payed(payment) &&
                              payment.reciboPago[0].estadoPago
                          "
                          variant="pagado"
                          >{{ text_payed(payment) }}</b-badge
                        >
                        <b-badge
                          v-else-if="active_oneclick(payment)"
                          variant="sin-pagar"
                          >Programado</b-badge
                        >
                        <b-badge v-else variant="sin-pagar">Sin Pagar</b-badge>
                      </h5>
                    </b-td>
                    <b-td>
                      <b-button
                        block
                        v-if="is_payed(payment)"
                        squared
                        variant="gold"
                        class="my-2 my-sm-0"
                        type="button"
                        :href="payment.urlReport"
                        target="_blank"
                        :disabled="
                          text_payed(payment) == 'Documentado' &&
                          payment.reciboPago[0].tipoPago == 'Cheque'
                            ? true
                            : false
                        "
                        >Recibo</b-button
                      >
                      <b-button
                        block
                        v-else
                        squared
                        @click="showModal(payment)"
                        variant="argenta"
                        class="my-2 my-sm-0"
                        type="button"
                        :href="payment.urlReport"
                        :disabled="payment.montoPago == 0 ? true : false"
                        >Pagar</b-button
                      >
                    </b-td>
                  </b-tr>
                  <b-tr :key="'small-pay-tr' + key" class="d-lg-none">
                    <b-td>
                      <b>{{ payment.descripcionPago }}</b> <br />
                      {{
                        new Intl.NumberFormat("es-CL").format(payment.montoPago)
                      }}
                      UF <br />
                      <small>{{
                        payment.fechaVencimientoPago | moment("DD-MM-YYYY")
                      }}</small>
                      <h5>
                        <b-badge v-if="is_payed(payment)" variant="success"
                          >Pagado</b-badge
                        >
                        <b-badge v-else variant="secondary">Sin Pagar</b-badge>
                      </h5>
                    </b-td>
                    <b-td class="align-middle text-right">
                      <b-button
                        block
                        v-if="is_payed(payment)"
                        squared
                        variant="gold"
                        class="my-2 my-sm-0"
                        type="button"
                        :href="payment.urlReport"
                        target="_blank"
                        >Recibo</b-button
                      >
                      <b-button
                        block
                        v-else
                        squared
                        @click="showModal(payment)"
                        variant="argenta"
                        class="my-2 my-sm-0"
                        type="button"
                        :href="payment.urlReport"
                        :disabled="payment.montoPago == 0 ? true : false"
                        >Pagar</b-button
                      >
                    </b-td>
                  </b-tr>
                </template>
              </tbody>
            </b-table-simple>
          </b-col>
        </b-row>
        <div class="text-center">
          <jw-pagination
            :pageSize="10"
            :items="payment_data.payments"
            @changePage="onChangePage"
            :styles="customStyles"
            :labels="customLabels"
            squared
            align="center"
          ></jw-pagination>
        </div>
        <b-modal
          ref="my-modal"
          hide-footer
          :title="'Pago de Cuota ' + transbank.id"
        >
          <b-overlay
            :show="transbank.loading"
            rounded="lg"
            spinner-variant="gold"
          >
            <div class="d-block text-center">
              <h3>
                <small>Monto: </small>$
                {{ new Intl.NumberFormat("es-CL").format(transbank.monto) }}
              </h3>
            </div>
            <form
              id="webpay-form"
              ref="form"
              action="https://webpay3g.transbank.cl:443/webpayserver/initTransaction"
              accept-charset="UTF-8"
              method="post"
            >
              <input
                id="webpay-token"
                type="hidden"
                name="token_ws"
                v-model="transbank.token"
              />
            </form>
            <b-button
              class="mt-2"
              variant="argenta"
              block
              @click="webpay_payment"
              >Pagar</b-button
            >
          </b-overlay>
        </b-modal>
      </b-overlay>
    </div>
  </b-container>
</template>
<script>
export default {
  name: "payments",
  components: {},
  props: {
    project_id: null,
    asset_id: null,
  },
  data() {
    return {
      showPayment: false,
      customStyles: {
        li: {
          display: "inline-block",
        },
        a: {
          color: "black",
        },
      },
      customLabels: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      transbank: {
        token: "",
        url: "",
        monto: "",
        concept: "",
        back_url: window.location.href,
        id: "",
        loading: false,
      },
      pageOfItems: [],
      Apartment: null,
      loading: true,
      payment_data: {
        contract_number: "",
        payments: [],
        loading: null,
      },
    };
  },
  mounted() {
    this.apartment = this.$store.getters.getApartmentById(
      parseInt(this.asset_id),
    );
    this.showPayment = true;
    let self = this;
    this.axios.get("payments/").then((result) => {
      result.data.map(function(value) {
        self.loading = false;
        value.bienes.map(function(v) {
          if (self.asset_id == v.id) {
            self.payment_data.contract_number = value.id;
            self.Apartment = v;
            self.payment_data.payments = value.pagos;
            self.payment_data.loading = false;
          }
        });
      });
    });
  },
  computed: {
    have_cards() {
      return this.$store.getters.getCards != undefined;
    },
  },
  methods: {
    text_payed(payment) {
      return payment.reciboPago[0].estadoPago;
    },
    active_oneclick(payment) {
      if (
        this.$store.getters.getCards.length > 0 &&
        payment.descripcionPago == "Financiamiento Propio"
      ) {
        return this.have_cards;
      } else {
        return false;
      }
    },
    webpay_payment() {
      this.transbank.loading = true;
      this.axios
        .post("payments/webpay", { transbank: this.transbank })
        .then((result) => {
          this.transbank.token = result.data.token;
          this.transbank.url = result.data.url;
          this.transbank.loading = false;
          if (result.data.token)
            document.getElementById("webpay-token").value = result.data.token;
          document.getElementById("webpay-form").action = result.data.url;
          document.getElementById("webpay-form").submit();
        })
        .catch(() => {
          this.transbank.loading = false;
        });
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    showModal(payment) {
      this.$refs["my-modal"].show();
      this.transbank.id = payment.codigo;
      this.transbank.monto = parseInt(payment.montoPago * payment.valorUF);
    },
    is_payed(payment) {
      if (payment.reciboPago === undefined) {
        return false;
      } else {
        return payment.reciboPago.length > 0;
      }
    },
  },
};
</script>
<style></style>
